import api from './api';

const authService = {
  login: async (email, password) => {
    try {
      const response = await api.post(`/auth/login`, {
        email,
        password
      });

      if (response.data.success && response.data.account) {
        localStorage.setItem('user', JSON.stringify(response.data.account));
      }

      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Er is een fout opgetreden.'
      };
    }
  },

  register: async (firstName, lastName, email, password, confirmPassword) => {
    try {
      const response = await api.post(`/auth/register`, {
        firstName,
        lastName,
        email,
        confirmEmail: email,
        password,
        confirmPassword
      });

      if (response.data.success && response.data.account) {
        localStorage.setItem('user', JSON.stringify(response.data.account));
      }

      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Er is een fout opgetreden.'
      };
    }
  },

  logout: () => {
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('user');
  },

  forgotPassword: async (email) => {
    try {
      const response = await api.post(`/auth/forgot-password`, {
        email
      });

      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Er is een fout opgetreden.'
      };
    }
  },

  verifyResetToken: async (token) => {
    try {
      const response = await api.post(`/auth/verify-reset-token`, {
        token
      });

      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Er is een fout opgetreden.'
      };
    }
  },

  resetPassword: async (token, password, confirmPassword) => {
    try {
      const response = await api.post(`/auth/reset-password`, {
        token,
        password,
        confirmPassword
      });

      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Er is een fout opgetreden.'
      };
    }
  }
};

export default authService;
